<template>
  <div class="d-flex">
    <check-box-field
      :field="field"
      :showLabel="true"
      :label="label"
    ></check-box-field>
    <fb-field-config :field="field"></fb-field-config>
  </div>
</template>

<script>
import { getSettings } from "../../assets/js/common.helper";
import CheckBoxField from "../ui/form/CheckBoxField.vue";
import FbFieldConfig from "./FbFieldConfig.vue";
export default {
  props: { field: {} },
  components: { FbFieldConfig, CheckBoxField },
  computed: {
    label() {
      return this.field.Form_Label;
    },
    settings() {
      return getSettings({ ...this.field });
    },
  },
};
</script>

<style>
</style>